export default "__VITE_ASSET__DOmTgzQU__"